import IntelliProveAuthenticationError from '~/errors/authentication_errors';
import { AuthenticationMethod } from '~/services/api';
import { errorEvent } from '~errors/emitter';
import { replaceAll } from '~utils/strings';

export const getSearchParam = (key: string): string | null => {
  const params = new URLSearchParams(window.location.search);
  const val = params.get(key);
  if (val) return replaceAll(val, ' ', '+');
  return val || null;
};

export const validSearchParam = (key: string): boolean => {
  const val = getSearchParam(key);
  if (!val) return false;
  try {
    if (JSON.parse(val)) return true;
  } catch (e) {
    errorEvent.emit({ error: e, message: `'${key}' search param exists, but JSON.parse failed. Value -> ${val}` });
  }
  return false;
};

export function getAuthFromSearchParams(): [string, AuthenticationMethod] {
  let key = getSearchParam('action_token');
  if (key) return [key, AuthenticationMethod.ActionToken];
  key = getSearchParam('auth0');
  if (key) return [key, AuthenticationMethod.Auth0];

  throw new IntelliProveAuthenticationError("Missing search params 'action_token' or 'auth0'");
}
